// src/App.js
import React, { Suspense } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import Metrics from './metrics/metrics';
import StructuredData from './components/seo/StructuredData';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import PatternReadingBar from './components/patterns/PatternReadingBar';
import routes from './constants/routes';
import CookieBanner from './components/CookieBanner';
import { ToastContainer } from 'react-toastify';
import { AuthProvider } from './auth/context/AuthContext';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { ThemeModeProvider } from './theme/ThemeModeProvider';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';

const PageLoader = () => (
	<Box sx={{
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		minHeight: '60vh',
	}}>
		<CircularProgress sx={{ color: 'var(--gof-color-accent)' }} />
	</Box>
);

const organizationSchema = {
	'@context': 'https://schema.org',
	'@type': 'Organization',
	name: 'GOFINSIGHTS',
	url: 'https://gofinsights.com',
	description: 'Справочник всех 23 паттернов проектирования GoF с примерами кода на 9 языках и AI-тренажером для разработчиков.',
	contactPoint: {
		'@type': 'ContactPoint',
		email: 'support@gofinsights.com',
		contactType: 'customer support',
	},
	sameAs: ['https://t.me/Gofinsights_bot'],
	inLanguage: 'ru',
};

const AppContent = () => {
	const location = useLocation();
	const excludeOverlay = ['/terms-of-service', '/privacy-policy'].includes(location.pathname);

	return (
		<div className="app-content" style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
			<StructuredData data={organizationSchema} />
			<Metrics />
			{!excludeOverlay && <CookieBanner />}
			<ScrollToTop />
			<Navbar />
			<PatternReadingBar />
			<main style={{ flex: 1 }}>
				<Suspense fallback={<PageLoader />}>
					<Routes>
						{routes.map((route, index) => (
							<Route key={index} path={route.path} element={route.element} />
						))}
					</Routes>
				</Suspense>
			</main>
			<Footer />
			<ToastContainer
				position="bottom-right"
				autoClose={3000}
				hideProgressBar={false}
				newestOnTop={false}
				closeOnClick
				rtl={false}
				pauseOnFocusLoss
			/>
		</div>
	);
};

const App = () => (
	<ThemeModeProvider>
		<Router>
			<AuthProvider>
				{process.env.REACT_APP_GOOGLE_CLIENT_ID ? (
					<GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
						<AppContent />
					</GoogleOAuthProvider>
				) : (
					<AppContent />
				)}
			</AuthProvider>
		</Router>
	</ThemeModeProvider>
);

export default App;
